import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";
import {
    mailingLists,
    mailingListsLoading,
    editingMailingList,
    submittingMailingListState,
    submitMailingListLoading,
    mailingTypes,
    mailingTypesLoading,
    mailingListLoading
} from "../reducers/mailingLists.reducer";

import {
    subsidiaries,
    subsidiariesLoading
} from "../reducers/subsidiaries.reducer";

const mailingReducer = combineReducers({
    mailingLists,
    mailingListsLoading,
    editingMailingList,
    submittingMailingListState,
    submitMailingListLoading,
    subsidiaries,
    subsidiariesLoading,
    mailingTypes,
    mailingTypesLoading,
    mailingListLoading
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Mailing Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const mailingStore = createStore(
    mailingReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const mailingStoreSelectors = {
    mailingLists: (state = mailingStore.getState()) => state.mailingLists,
    mailingListsLoading: (state = mailingStore.getState()) =>
        state.mailingListsLoading,
    editingMailingList: (state = mailingStore.getState()) => state.editingMailingList,
    submittingMailingListState: (state = mailingStore.getState())=> state.submittingMailingListState,
    submitMailingListLoading: (state = mailingStore.getState())=> state.submitMailingListLoading,
    subsidiaries: (state = mailingStore.getState()) => state.subsidiaries,
    subsidiariesLoading: (state = mailingStore.getState()) =>
        state.subsidiariesLoading,
    mailingTypes: (state = mailingStore.getState()) => state.mailingTypes,
    mailingTypesLoading: (state = mailingStore.getState()) => state.mailingTypesLoading,
    mailingListLoading: (state = mailingStore.getState()) => state.mailingListLoading
};

sagaMiddleware.run(rootSaga);
